// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4442":"a140423b","6641":"a140423b"}[chunkId] + ".chunk.css";
};